import React, { use, useEffect } from 'react'
import AltDataGridPro from '../../common/data-grids/ALTDataGrid'
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ShareIcon from '@mui/icons-material/Share';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { getAnalyzedDocuments } from '../../services/services';
import secureLocalStorage from 'react-secure-storage';

const DocumentsHistory = () => {

  //#region variables
  const navigate = useNavigate();
  const [analyzedDocuments, setAnalyzedDocuments] = useState([]);

  //#region columns
  const columns = [
    { 
      field: "icon", 
      headerName: "Icon", 
      width: 60, 
      renderCell: (params) => (
        <div className='display-center' style={{ marginTop: '13px'}}>
          <TextSnippetIcon color='primary' sx={{ width: 24,height: 24 }} />
        </div>
      )
    },
    { field: "uploadedDocmentName", headerName: "Title", flex: 1 },
    /* { field: "insights", headerName: "Insights", flex: 1,
      renderCell: (params) => (
        <div className='display-center'>
          -
        </div>
      )
    },
    { field: "riskFlags", headerName: "Risk Flags", flex: 1,
      renderCell: (params) => (
        <div className='display-center'>
        -
        </div>
      )
    }, */
    {
      id: 4,
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      cellClassName: 'actions',
      flex: 1,
      getActions: ({ id, row }) => {
        const getActionItems = (row) => {
          const actions = [
            <Tooltip title="View Report" key="view">
              <GridActionsCellItem
                icon={<VisibilityIcon />}
                label="View"
                className="textPrimary"
                onClick={() => handleViewReport(row)}
                color="inherit" />
            </Tooltip>,
           
          ];
          return actions;
        };

        return getActionItems(row);
      }
    },
  ];

   {/* <Tooltip title="Download Report" key="download">
              <GridActionsCellItem
                icon={<FileDownloadIcon />}
                label="Download"
                className="textPrimary"
                onClick={() => { }}
                color="inherit" />
            </Tooltip>,
            <Tooltip title="Share Report" key="share">
              <GridActionsCellItem
                icon={<ShareIcon />}
                label="Share"
                className="textPrimary"
                onClick={() => { }}
                color="inherit" />
            </Tooltip>, */}

  //#region click events
  const handleViewReport = (row) => {
    secureLocalStorage.setItem("documentId", row?.docAnalysisID);
    navigate(`/analysis-report`);
  };

  //#region api get calls
  const getAllDocuments = async () => {
    const response = await getAnalyzedDocuments();
    if(response?.status === 200) {
      const formattedData = response.data?.sort((a, b) => new Date(b.updatedOn) - new Date(a.updatedOn));
      setAnalyzedDocuments(formattedData);
    }
    else{
      console.error("Failed to fetch documents", response);
    }
  }

  //#region useeffect
  useEffect(() => {
    getAllDocuments();
  }, []);

  //#Region return
  return (
    <div className='padding-40'>
      <div className='header-text'>Document Analysis</div>
      <span>AI-powered financial document analysis</span>
      <div className='white-card margin-top-20 height-400'>
        <AltDataGridPro 
          columns={columns}
          rows={analyzedDocuments?.map((item,index)=>({
            id: index,
            ...item
          }))}/>
      </div>
    </div>
  )
}

export default DocumentsHistory